export default __webpack_public_path__ + "static/media/Right.24cdf886.png";